/**
 * This component is derived from https://github.com/cudr/react-modal-promise
 */
import {Container} from './Container'

export * from './types'
export * from './Container'

export default Container
